import { getAreas, getArea, saveArea, deleteArea, findNewsletterByTypeId } from '../../shared/data-services/area-service';

export async function getAllAreas (companyId){
  const data = await getAreas(companyId);
  return data || [ ];
};

export async function getSelectedArea (id){
  const data = await getArea(id);
  return data;
};

export async function saveSelectedArea (areaId, name, companyId){
  const Area = {
    areaId, 
    name,
    companyId
  }

  const data = await saveArea(Area);
  return data;
};

export async function deleteSelectedArea (id){
  const data = await deleteArea(id);
  return data;
};

export async function NewsletterByTypeId (typeId){
  const data = await findNewsletterByTypeId(typeId);
  return data;
};